import { type FunctionComponent } from 'react';
import * as React from 'react';

import { BaseMultiSelect } from '../Common/Select/BaseMultiSelect.tsx';
import { NoResultsOption } from '../Common/Select/components/NoResultsOption/NoResultsOption.tsx';

import { type CommonMultiSelectProps } from '../Common/Select/BaseMultiSelect.tsx';

export type MultiSelectProps = CommonMultiSelectProps & {
    maskForPrivacy?: boolean;
    noResultsPrompt: React.ReactNode;
    searchable?: boolean;
    deselectable?: boolean;
};

export const MultiSelect: FunctionComponent<MultiSelectProps> = props => {
    const { noResultsPrompt, ...commonProps } = props;

    return (
        <BaseMultiSelect
            {...commonProps}
            customDropdownOption={({ filteredOptions, inputValue, isLoading }) => {
                if (filteredOptions.length === 0 && inputValue && !isLoading) {
                    return <NoResultsOption>{noResultsPrompt}</NoResultsOption>;
                } else {
                    return null;
                }
            }}
        />
    );
};
